<template>
  <ubi-page-container>
    <div v-loading="loading"
         :element-loading-text="$t('portals.list.chargementDonnees')">
      <!--DEBUT : LE CLIENT N'A PAS CONTACT MANAGER-->
      <ubi-panel v-if="!this.possedeContactManager && possedeCallTracking == false">
        <h1>{{ $t("contacts.noActivated.title") }}</h1>
        <div style="margin-left: 5%; margin-right: 5%;">
          <h3 class="text-center">
            <strong>{{ $t("contacts.noActivated.title1") }}</strong>
          </h3>
          <br/>
          <p class="text-center" v-html="$t('contacts.noActivated.text1')"/>
          <br/><br/>
          <h3>{{ $t("contacts.noActivated.title2") }}</h3>
          <p class="text-justify">{{ $t("contacts.noActivated.text2") }}</p>
          <br/>
          <h3>{{ $t("contacts.noActivated.title3") }}</h3>
          <p class="text-justify">{{ $t("contacts.noActivated.text3") }}</p>
          <br/>
          <h3>{{ $t("contacts.noActivated.title4") }}</h3>
          <p class="text-justify">{{ $t("contacts.noActivated.text4") }}</p>
          <br/>
          <h3>{{ $t("contacts.noActivated.title5") }}</h3>
          <p class="text-justify">{{ $t("contacts.noActivated.text5") }}</p>
        </div>
        <br />
        <br />
        <div class="text-center">
          <el-row>
            <el-button v-if="!isSubUser" @click="send">{{ $t("contacts.noActivated.beContacted") }}</el-button>
          </el-row>
          <br/>
          <el-row>
            <el-button type="primary" @click="eventAnalytics('decouvrir_produit')">
              <a href="https://lp.ubiflow.net/en-savoir-plus-sur-contact-manager-0" target="_blank"
                 id="lienBouton2" rel="noopener">{{ $t("contacts.noActivated.discover") }}</a>
            </el-button>
          </el-row>
        </div>
      </ubi-panel>
      <!--FIN : LE CLIENT N'A PAS CONTACT MANAGER-->

      <div v-if="this.possedeContactManager || possedeCallTracking == true">
        <BoxInfos v-if="showBoxInfos" @closeBoxInfos="closeBoxInfos" :has-icon-info="false" :has-icon-close="true">
            <span style="font-size: 18px;font-weight: lighter" class="mr-1">{{$t('contact.messageLeadsQualification')}}</span>
          <router-link :to="{name: 'ProduitQualiforma'}" style="font-size: 18px;">ici</router-link> !
        </BoxInfos>
        <el-form @submit.prevent.native="fetchData">
          <ubi-panel style="background-color: #EBF3F2;">
            <ubi-search-container
                    :defaultFilter="this.filter.preset"
                    :filters="filters"
                    @filter="fetchData"
                    v-on:resetfilter="doFilter('reset')">
              <el-row>
                <el-col :span="16">
                  <el-form-item :label="$t('general.filters.date')">
                    <el-date-picker
                        type="daterange"
                        :value="filter.beforeContacts || filter.afterContacts? [
                          filter.beforeContacts || undefined,
                          filter.afterContacts || undefined
                        ] : null"
                        :start-placeholder="$t('general.filters.dateCreationStart')"
                        :end-placeholder="$t('general.filters.dateCreationEnd')"
                        @input="
                          dates => addFilter({ beforeContacts: dates? dates[0] : null, afterContacts: dates ? dates[1] : null})
                        "
                        format="dd/MM/yyyy"
                        :picker-options="pickerOptions"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </ubi-search-container>
          </ubi-panel>
        </el-form>
        <ubi-panel :title="$t('contacts.accumulatedIndicators')">
          <el-row>
            <el-col :span="8" v-if="nbContactsGeneres > 0 && !user.roles.includes('ROLE_SUB_USER')" >
              <el-button v-loading="loadingExport" @click="exporterContacts">
                {{ $t("contacts.exportEmailContacts") }}
              </el-button>
            </el-col>
            <el-col :span="8">
              <strong>{{nbContactsGeneresTotal + totalContactsCalltracking}}</strong>
              {{ $t("contacts.generatedContactsTotal", {count: nbContactsGeneresTotal + totalContactsCalltracking}) }}
              <el-tooltip placement="top-start" :content="$t('contacts.tooltipTotal')">
                <em class="el-icon-question"></em>
              </el-tooltip>
              <br>
              <strong>{{nbContactsGeneres}}</strong>
              {{ $t("contacts.generatedContactsActiveAds", {count: nbContactsGeneres}) }}
              <el-tooltip placement="top-start" :content="$t('contacts.tooltipActiveAds')">
                <em class="el-icon-question"></em>
              </el-tooltip>
            </el-col>
            <el-col :span="8" v-if="possedeCallTracking">
              <strong>{{nbContactsGeneresTotal}}</strong> {{ $t("contacts.contactsByEmail") }}
              <br />
              <strong>{{totalContactsCalltracking}}</strong> {{ $t("contacts.contactsByPhone") }}
              <br />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <br />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-button class="inline" v-if="possedeCallTracking && totalContactsCalltracking > 0" @click="exportCalls">
                  {{ $t("contacts.exportPhoneContacts") }}
              </el-button>
            </el-col>
            <el-col :span="8">
              <br />
              <strong>{{ nbAnnoncesDiffusees }}</strong> {{ nbAnnoncesDiffusees ? $t("contacts.adsSent_plural") : $t("contacts.adsSent") }}
              <br />
              <strong>{{ nbPortailsActifs }}</strong> {{ nbPortailsActifs ? $t("contacts.activePortals_plural") : $t("contacts.activePortals") }}
              <br />
            </el-col>
            <el-col :span="8"></el-col>
            <el-row v-if="isPromoteur">
              <el-col :lg="8" class="mb-3">
                <br/>
                <strong>{{ $t("portals.broadcast.quotaProgram") }} :</strong>
                <br/>
                <div>{{ this.nbAnnoncesDiffuseesProgrammes}} / {{ this.nbProgrammesTotal}}</div>
              </el-col>
              <el-col :lg="8" class="mb-3">
                <br/>
                <strong>{{ $t("portals.broadcast.quotaLot") }} :</strong>
                <br/>
                <div>{{ this.nbAnnoncesDiffuseesLots}} / {{ this.nbLotsTotal}}</div>
              </el-col>
            </el-row>
          </el-row>
        </ubi-panel>

        <ubi-panel :title="$t('contacts.activityDistributionTitle')" v-if="this.sitimmoUser.univers == 'IMMO'">
          <el-row>
            <el-col :span="7">
              <div class="text-muted" style="text-align: center;">
                <pie-chart
                    :chart-data="graphDataTypesOffres"
                    :options="null"
                    v-if="graphDataTypesOffres != null"
                ></pie-chart>
                <div v-else style="text-align: center;">{{ $t("contacts.activityDistributionNoData") }}</div>
                <br>{{ $t("contacts.activityDistributionOffers") }}
              </div>
            </el-col>
            <el-col :span="1">
              <br />
            </el-col>
            <el-col :span="7">
              <div class="text-muted" style="text-align: center;">
                <pie-chart
                    :chart-data="graphDataTypesBiens"
                    :options="null"
                    v-if="graphDataTypesBiens != null"
                ></pie-chart>
                <div v-else style="text-align: center;">{{ $t("contacts.activityDistributionNoData") }}</div>
                <br>{{ $t("contacts.activityDistributionProperties") }}
              </div>

            </el-col>
            <el-col :span="1">
              <br />
            </el-col>
            <el-col :span="7">
              <div class="text-muted" style="text-align: center;">
                <pie-chart
                    :chart-data="graphDataPortals"
                    :options="null"
                    v-if="graphDataPortals != null"
                ></pie-chart>
                <div v-else style="text-align: center;">{{ $t("contacts.activityDistributionNoData") }}</div>
                <br>{{ $t("contacts.activityDistributionPortals") }}
              </div>
            </el-col>
          </el-row>
        </ubi-panel>
        <ubi-panel :title="$t('contacts.activityDistributionTitleVO')" v-else>
          <el-row type="flex" justify="left">
            <el-col :span="16">
              <bar-chart-horizontal :chart-data="graphDataPortals" v-if="!aucunPortail"></bar-chart-horizontal>
              <div class="text-muted text-center" v-else>{{ $t("contacts.activityDistributionNoData") }}</div>
            </el-col>
          </el-row>
        </ubi-panel>

        <ubi-panel :title="$t('contacts.contactDetailsTitle')" >
          <el-row>
            <el-col :span="12">
              <div class="text-muted" style="text-align: center;">
                <bar-chart :chart-data="graphDataMonthly" ></bar-chart>{{ $t("contacts.contactDetailsLastMonths") }}
              </div>
            </el-col>
            <el-col :span="12">
              <div class="text-muted" style="text-align: center;">
                <bar-chart :chart-data="graphDataDaily" ></bar-chart>{{ $t("contacts.contactDetailsLastDays") }}
              </div>
            </el-col>
          </el-row>
        </ubi-panel>
      </div>
    </div>
  </ubi-page-container>

</template>

<script>
import moment from 'moment'
import { getSwitchedToken } from '@/services/auth'
import { Collapse, CollapseItem, Divider } from 'element-ui'
import { mapState, mapMutations, mapGetters } from 'vuex'
import {
  getContactsAnnoncesEnTete,
  getMonthlyContacts,
  getDailyContacts,
  getNbCalls,
  orderNbCalls,
  exportContacts,
  getContactsPortailEnTete,
  exportCalls, getContactsPortailsEnTete
} from '@/services/contacts'
import PieChart from '../../services/piechart'
import BarChart from '../../services/barchart'
import BarChartHorizontal from '../../services/barchartHorizontal.js'
import { sendEmail } from '@/services/email'
import { getNbTotalLots, getNbTotalProgrammes } from '@/services/posts'
import downloadexcel from 'vue-json-excel'
import BoxInfos from '@/components/ui/BoxInfos.vue'

export default {
  name: 'SyntheseContacts',
  inject: ['browserContext'],
  components: {
    BoxInfos,
    PieChart,
    BarChart,
    BarChartHorizontal,
    ElCollapse: Collapse,
    ElCollapseItem: CollapseItem,
    ElDivider: Divider,
    downloadexcel
  },
  data () {
    return {
      loading: false,
      nbResults: 0,
      enTete: null,
      contactsAnnoncesEnTete: null,
      contactsPortailEnTete: null,
      contactsPortailsEnTete: null,
      graphDataTypesBiens: null,
      graphDataTypesOffres: null,
      totalContactsCalltracking: 0,
      graphDataPortals: null,
      nbContactsGeneres: 0,
      nbContactsGeneresTotal: 0,
      nbProspects: 0,
      nbAnnonces: 0,
      contacts: null,
      nbPortailsActifs: 0,
      totalAnnonces: 0,
      contactsMonthly: null,
      contactsDaily: null,
      graphDataMonthly: null,
      graphDataDaily: null,
      graphData: {},
      aucunPortail: false,
      marginLeftContacts: 0,
      marginLeftPortails: 0,
      nbAnnoncesDiffuseesLots: 0,
      nbAnnoncesDiffuseesProgrammes: 0,
      nbAnnoncesDiffusees: 0,
      nbLotsTotal: 0,
      nbProgrammesTotal: 0,
      filters: [],
      annoncesStats: {},
      infosPortails: [],
      loadingExport: false,
      showBoxInfos: true
    }
  },
  beforeMount () {
    this.filter.beforeContacts = this.$store.getters['donnees/getContactsDateBefore']
    this.filter.afterContacts = this.$store.getters['donnees/getContactsDateAfter']
    this.fetchData()
  },
  computed: {
    ...mapGetters(['isSubUser', 'getPickerOptionsShortcuts']),
    ...mapState('contacts', ['filter', 'results']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    possedeContactManager () {
      return this.sitimmoUser.possede_contact_manager
    },
    possedeCallTracking () {
      return this.sitimmoUser.possede_call_tracking
    },
    cockpitLogin () {
      return this.sitimmoUser.cockpitLogin
    },
    user () {
      return this.$store.getters.getUser
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    saveFilters () {
      return this.$store.state.saveFilters
    },
    pickerOptions () {
      return {
        shortcuts: this.getPickerOptionsShortcuts
      }
    }
  },
  mounted () {
    this.userEmail = this.user.email
  },
  methods: {
    async getEnTete () {
      this.enTete = await getContactsPortailEnTete(this.filter, this.portalId)
    },
    convertDate: function (date) {
      return 'Le ' + moment(date).format('DD/MM/YYYY à hh:mm:ss')
    },
    ...mapMutations('contacts', [
      'setPage',
      'setLimit',
      'setSort',
      'setSearch',
      'setCategory',
      'setGratuit',
      'setFilter',
      'addFilter',
      'setResults',
      'setOffset',
      'resetFilter'
    ]),
    eventAnalytics (category) {
      this.$ga.event('contact_manager', 'clic', category, this.sitimmoUser.id)
    },
    findNbContacts (annonce) {
      for (const [key, value] of Object.entries(this.annoncesStats)) {
        if (key === annonce.reference) {
          annonce.nbContactsMailtracking = value
        }
      }
      if (annonce.nbContactsMailtracking === null) {
        annonce.nbContactsMailtracking = 0
      }
    },
    closeBoxInfos (args) {
      if (args === 'close') {
        this.showBoxInfos = false
      }
    },
    async fetchData () {
      this.setLoading(true)
      try {
        this.commitFilters()

        const [contactsAnnoncesEnTete, contactsPortailEnTete, contactsPortailsEnTete, monthlyContacts, dailyContacts, nbCalls] = await this.fetchAllData()

        this.validateResults(contactsAnnoncesEnTete, contactsPortailsEnTete, contactsPortailEnTete, nbCalls)

        this.processData(contactsAnnoncesEnTete, contactsPortailEnTete, contactsPortailsEnTete, monthlyContacts, dailyContacts, nbCalls)

        if (this.isPromoteur) {
          await this.chargementPromoteur()
        }

        this.generateGraphs()
      } catch (error) {
        this.handleError(error)
      } finally {
        this.setLoading(false)
      }
    },
    commitFilters () {
      this.$store.commit('donnees/SET_CONTACTS_DATE_BEFORE', this.filter.beforeContacts)
      this.$store.commit('donnees/SET_CONTACTS_DATE_AFTER', this.filter.afterContacts)
    },
    async fetchAllData () {
      return await Promise.all([
        getContactsAnnoncesEnTete(this.filter),
        getContactsPortailEnTete(this.filter),
        getContactsPortailsEnTete(this.filter),
        getMonthlyContacts(),
        getDailyContacts(),
        getNbCalls(this.filter, null)
      ])
    },
    validateResults (contactsAnnoncesEnTete, contactsPortailEnTete, nbCalls) {
      if (contactsAnnoncesEnTete.type === 'error' || contactsPortailEnTete.type === 'error' || nbCalls.type === 'error') {
        throw new Error(this.$t('error.found'))
      }
    },
    processData (contactsAnnoncesEnTete, contactsPortailEnTete, contactsPortailsEnTete, monthlyContacts, dailyContacts, nbCalls) {
      this.contactsAnnoncesEnTete = contactsAnnoncesEnTete
      this.contactsPortailEnTete = contactsPortailEnTete
      this.contactsPortailsEnTete = contactsPortailsEnTete
      this.contactsMonthly = { infos: monthlyContacts.data }
      this.contactsDaily = { infos: dailyContacts.data }
      this.callsPerPortal = orderNbCalls(nbCalls)
      this.updateStatistics()
    },
    updateStatistics () {
      this.totalContactsCalltracking = this.callsPerPortal.TOTAL_CONTACTS_CALLTRACKING
      this.nbContactsGeneres = this.contactsAnnoncesEnTete.infos.nbContactsGeneres
      this.nbContactsGeneresTotal = this.contactsAnnoncesEnTete.infos.nbContactsGeneresTotal
      this.nbAnnonces = this.contactsAnnoncesEnTete.infos.nbAnnonces
      this.nbProspects = this.contactsAnnoncesEnTete.infos.nbProspects
      this.nbPortailsActifs = this.contactsAnnoncesEnTete.infos.nbPortailsActifs
      this.nbAnnoncesDiffusees = this.contactsAnnoncesEnTete.infos.nbAnnoncesDiffusees
      this.nbAnnoncesDiffuseesLots = this.contactsPortailsEnTete.infos.nbAnnoncesDiffuseesLots
      this.nbAnnoncesDiffuseesProgrammes = this.contactsPortailsEnTete.infos.nbAnnoncesDiffuseesProgrammes
      this.annoncesStats = this.contactsAnnoncesEnTete.infos.infosAnnonces
      const dataPortails = this.contactsPortailEnTete.infos.infosPortails
      for (const [key, value] of Object.entries(dataPortails)) {
        this.infosPortails[value.nom] = value.nb_contacts
      }
    },
    generateGraphs () {
      this.graphDataTypesBiens = this.createGraphData(this.contactsAnnoncesEnTete.infos.tabTypesObject, [
        'rgba(255,99,132,0.55)',
        'rgba(54, 162, 235, 0.55)',
        'rgba(255, 206, 86, 0.55)',
        'rgba(75, 192, 192, 0.55)',
        'rgba(153, 102, 255, 0.55)',
        'rgba(255, 159, 64, 0.55)'
      ])
      this.graphDataTypesOffres = this.createGraphData(this.contactsAnnoncesEnTete.infos.tabTypesOffre, [
        'rgba(255, 206, 86, 0.55)',
        'rgba(75, 192, 192, 0.55)',
        'rgba(153, 102, 255, 0.55)',
        'rgba(255, 159, 64, 0.55)'
      ])
      this.graphDataPortals = this.createGraphData(this.infosPortails, [
        'rgba(54, 162, 235, 0.55)',
        'rgba(255,206,86,0.55)',
        'rgba(75, 192, 192, 0.55)',
        'rgba(153, 102, 255, 0.55)',
        'rgba(255, 159, 64, 0.55)'
      ])
      this.graphDataDaily = this.createGraphData(this.contactsDaily.infos, [
        'rgba(255, 99, 132, 0.55)',
        'rgba(54, 162, 235, 0.55)',
        'rgba(255, 206, 86, 0.55)',
        'rgba(75, 192, 192, 0.55)',
        'rgba(153, 102, 255, 0.55)',
        'rgba(255, 159, 64, 0.55)'
      ])
      this.graphDataMonthly = this.createGraphData(this.contactsMonthly.infos, [
        'rgba(255, 99, 132, 0.55)',
        'rgba(54, 162, 235, 0.55)',
        'rgba(255, 206, 86, 0.55)',
        'rgba(75, 192, 192, 0.55)',
        'rgba(153, 102, 255, 0.55)',
        'rgba(255, 159, 64, 0.55)'
      ])
    },
    createGraphData (data, colors) {
      const labels = Object.keys(data).map(label => label.charAt(0).toUpperCase() + label.slice(1))
      const values = Object.values(data)
      return values.length > 0
        ? {
            labels: labels,
            datasets: [
              {
                label: '# of Votes',
                data: values,
                borderWidth: 0,
                backgroundColor: colors
              }
            ]
          }
        : null
    },
    setLoading (value) {
      this.loading = value
    },
    handleError (error) {
      this.$message({ message: error.message, type: 'error' })
    },
    doFilter (type) {
      if (type === 'reset') {
        this.resetFilter()
      }
      this.fetchData()
    },
    async exporterContacts () {
      this.eventAnalytics('export_contacts_mail')
      this.loadingExport = true
      this.filter.exportType = 'contact_mailtracking'
      const res = await exportContacts(this.filter)
      this.loadingExport = false
      this.$message(res)
    },
    async exportCalls () {
      this.loading = true
      const res = await exportCalls(this.filter, null, this.$t('contacts.filenameExportContactsCalls'))
      this.$message(res)
      this.loading = false
    },
    async send () {
      this.eventAnalytics('etre_contacte')
      this.loading = true
      this.sendTo = processEnvConfig.VUE_APP_ADRESSE_MAIL_CONTACT_MARKETING
      const logo = processEnvConfig.VUE_APP_IMAGE_FILIGRANE_MAIL
      const mailData = {
        to: this.sendTo,
        subject: this.$t('contacts.noActivated.emailSubject', { advertiser: this.user.advertiser }),
        content: '<div style="width: 700px; margin: auto;"> <div style="background-color: #255662; height: 140px; width: 700px; margin-bottom: 50px"> <img style="width: 350px; margin-top: 6%; margin-left: 29%" src="' + logo + '"> </div> <p style="font-family: Dosis, Arial, Helvetica, sans-serif; font-size: large;text-align: center;">' + this.$t('contacts.noActivated.emailContent', { advertiser: this.user.advertiser, companyName: this.sitimmoUser.nom, email: this.sitimmoUser.email, phoneNumber: this.sitimmoUser.telephone }) + '</p></div>'
      }
      const response = await sendEmail(mailData)
      if (response.type === 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.loading = false
        return false
      }
      window.alert('Vous souhaitez des informations sur notre produit Contact Manager. Notre équipe va prendre contact avec vous dans les meilleurs délais')
      this.loading = false
      window.alert(this.$t('contacts.noActivated.dialogMessage'))
    },
    async switchToCockpit () {
      const switchedToken = await getSwitchedToken(this.cockpitLogin)
      const switchURL = processEnvConfig.VUE_APP_COCKPIT_URL + '/login?token=' + switchedToken
      window.open(switchURL, '_blank')
    },
    async chargementPromoteur () {
      this.nbProgrammesTotal = await getNbTotalProgrammes('ag' + this.sitimmoUser.id, false)
      this.nbLotsTotal = await getNbTotalLots('ag' + this.sitimmoUser.id, false)
      if (this.nbProgrammesTotal.type === 'error' || this.nbLotsTotal.type === 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
      }
    }
  }
}
</script>

<style>
  #lienBouton1{
    color: grey;
    text-decoration: none;
  }
  #lienBouton2{
    color: white;
    text-decoration: none;
  }
  .el-loading-spinner{
    top:10%!important;
  }
</style>
